/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QrLoginDto } from '../../models/qr-login-dto';
import { TokensDto } from '../../models/tokens-dto';

export interface UserControllerQrLogin$Params {
      body: QrLoginDto
}

export function userControllerQrLogin(http: HttpClient, rootUrl: string, params: UserControllerQrLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<TokensDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerQrLogin.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokensDto>;
    })
  );
}

userControllerQrLogin.PATH = '/api/user/qr-login';
